package io.horion.cv.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw

@Composable
fun AlertMessage(
    message: String,
    isVisible: Boolean,
    onDismiss: () -> Unit,
    type: ToastType = ToastType.INFO,
    duration: Long = 3000
) {
    LaunchedEffect(isVisible, duration) {
        if (isVisible) {
            delay(duration)
            onDismiss()
        }
    }

    if (isVisible) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Fixed)
                .top(0.px)
                .left(0.px)
                .zIndex(9999),
            contentAlignment = Alignment.Center
        ) {
            // Box du message
            Box(
                modifier = Modifier
                    .backgroundColor(when(type) {
                        ToastType.SUCCESS -> Colors.Primary
                        ToastType.ERROR -> Colors.Red
                        ToastType.WARNING -> Colors.orange
                        ToastType.INFO -> Colors.Blue
                    })
                    .borderRadius(12.px)
                    .padding(leftRight = 24.px, topBottom = 16.px)
                    .zIndex(10000)
            ) {
                SpanText(
                    text = message,
                    modifier = Modifier
                        .fontSize(16.px)
                        .color(Colors.White)
                        .textAlign(TextAlign.Center)
                        .fontWeight(FontWeight.Medium)
                )
            }
        }
    }
}


// Énumération des types de toast
enum class ToastType {
    SUCCESS,
    ERROR,
    WARNING,
    INFO
}

// Hook pour gérer facilement le toast
@Composable
fun useToast(): UseToast {
    val scope = rememberCoroutineScope()
    var isVisible by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf("") }
    var type by remember { mutableStateOf(ToastType.INFO) }

    fun show(
        msg: String,
        toastType: ToastType = ToastType.INFO,
        duration: Long = 3000
    ) {
        message = msg
        type = toastType
        isVisible = true

        scope.launch {
            delay(duration)
            isVisible = false
        }
    }

    return UseToast(
        isVisible = isVisible,
        message = message,
        type = type,
        show = ::show,
        hide = { isVisible = false }
    )
}

data class UseToast(
    val isVisible: Boolean,
    val message: String,
    val type: ToastType,
    val show: (String, ToastType, Long) -> Unit,
    val hide: () -> Unit
)